import React from 'react'
import { useTranslation } from 'react-i18next'



export default function QuickActions({ currentView, changeView }: { currentView: string, changeView: (view: string) => void }) {


    function Button({ children, viewName }: { children: React.ReactNode, viewName: string }) {
        return (
            <button
                onClick={() => {
                    changeView(viewName);
                }}
                type="button"
                className="text-decoration-none text-light fs-6 border-0 rounded-4 mb-1 px-1"
                style={{
                    backgroundColor: currentView === viewName ? '#6c757d' : '#1F1F21',
                    transition: 'background-color 0.2s ease'
                }}
            >
                <div className="py-1 px-1 border-0 text-gradient d-flex align-items-center">
                    <span style={{ width: '20px', display: 'flex', justifyContent: 'center' }}>
                        {children}
                    </span>
                    <span className="ms-1">{t(`campaigns.view_${viewName}`)}</span>
                </div>
            </button>
        )
    }

    const { t } = useTranslation();
    return (
        <div className="card border-0 shadow-sm" style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}>
            <div className="card-body">
                <h6 className="card-title mb-3 fw-bold text-light">
                    {t('campaigns.quickActions')}
                </h6>
                <div className="d-flex flex-column gap-1">
                    <Button viewName='aiAssistant'>
                        <i className="bi bi-robot"></i>
                    </Button>
                    <Button viewName='processes'>
                        <i className="bi bi-diagram-3"></i>
                    </Button>
                    <Button viewName='collaborators'>
                        <i className="bi bi-people"></i>
                    </Button>
                </div>
            </div>
        </div>
    )
}